import { useCallback, useSyncExternalStore } from "react";

/** Phones: below Tailwind's `sm` breakpoint. */
export const PHONE_QUERY = "(max-width: 639px)";
/** Where the sidebar becomes a drawer: below Tailwind's `md` breakpoint. */
export const DRAWER_QUERY = "(max-width: 767px)";

/** Live result of a CSS media query (false where matchMedia is unavailable). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
